import React, { useState } from 'react'
import { Button, Card, Modal, Select, Space, Spin, Typography } from "antd";
import { ProductVersionModel } from '../../../models/product-interface';
import { SupportTier } from '../../../models/support-tier-interface';
import { RatePlan } from '../../../models/rate-plan-interface';
import { ProductRatePlan, ProductSupport } from '../../../models/product-rate-plan-interface';
import { CustomerServiceQueries } from '../../../queries/customer-service-queries';

const { Title } = Typography

type Props = {
  ratePlanName: string;
  productSupport: ProductSupport;
}

const ActiveRatePlanCard: React.FC<Props> = ({
  ratePlanName,
  productSupport
}) => {
  const deletePlanMutator = CustomerServiceQueries.useDeleteSupportFromProduct(productSupport?.productId);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const removeRatePlan = () => {
    setIsLoading(true);
    Modal.confirm({
      title: "Are you sure you want to remove this rate plan?",
      onOk: () => {
        deletePlanMutator.mutateAsync(productSupport).finally(() => {
          setIsLoading(false);
        });
      }
    })
  }

  return <Card className='cost-card' key={`rate-${ratePlanName}`}>
    <Spin spinning={isLoading}>
      <Space direction="vertical">
        <Title level={5}>
          Rate Plan
        </Title>
        <Title level={3} className="primary-text">
          {ratePlanName}
        </Title>
        <div>
          <Title level={5}>
            {productSupport?.supportTier.name}
          </Title>
          <div>
            {productSupport?.supportTier?.days}
          </div>
          <div>
            {productSupport?.supportTier?.timeString}
          </div>
          <div>
            {`${productSupport?.supportTier?.phone ? "Phone" : ""} ${productSupport?.supportTier?.phone && productSupport?.supportTier?.email ? "&" : ""} ${productSupport?.supportTier?.email ? "Email" : ""}`}
          </div>
        </div>
        <Button type="link" style={{paddingLeft: 0}} onClick={() => removeRatePlan()} danger>
          Remove
        </Button>
      </Space>
    </Spin>
  </Card>
}

export default ActiveRatePlanCard;